import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { booleanFlag, flag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { pickDefined, withClient } from './common.js';

export async function runCommand(args: ParsedArgs): Promise<CommandResult> {
  const text = args.positionals[1];
  if (!text) throw new CliError('run requires <zapscript-or-text>', ExitCode.Usage);
  const data = await withClient(args.options, (client) =>
    client.request(
      Methods.Run,
      pickDefined({
        text,
        type: flag(args.flags, 'type'),
        uid: flag(args.flags, 'uid'),
        data: flag(args.flags, 'data'),
        unsafe: booleanFlag(args.flags, 'unsafe'),
      }),
    ),
  );
  return {
    data,
    human: 'Run request accepted',
    warnings: [
      'Run RPC acceptance is not completion for asynchronous launch or control actions. Poll media active at a paced interval, allow platform-specific settling, and do not immediately run or stop again.',
    ],
  };
}

export async function stopCommand(args: ParsedArgs): Promise<CommandResult> {
  const data = await withClient(args.options, (client) => client.request(Methods.Stop));
  return {
    data,
    human: 'Stop request accepted',
    warnings: [
      'Stop RPC acceptance is not completion. Poll media active at a paced interval until clear, allow platform-specific settling, and do not immediately run or stop again.',
    ],
  };
}
